import { render, staticRenderFns } from "./home_Tab_video.vue?vue&type=template&id=501cadc6&scoped=true&"
import script from "./home_Tab_video.vue?vue&type=script&lang=js&"
export * from "./home_Tab_video.vue?vue&type=script&lang=js&"
import style0 from "./home_Tab_video.vue?vue&type=style&index=0&id=501cadc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501cadc6",
  null
  
)

export default component.exports